import { styled } from '@mui/material/styles';
import { Outlet, useNavigate } from 'react-router-dom';
import { Header, MenuItem } from '@bloomays-lib/ui.shared';
import { useAuthStore } from '@bloomays-lib/common.auth/browser';

const Bucket = () => {
  const navigate = useNavigate();
  const auth = useAuthStore((state) => state.auth);
  const user = auth?.user;

  return (
    <ContainerBucket>
      <Header
        returnToDashboard={() => navigate('/')}
        logout={user ? auth?.logout : undefined}
        user={user ? { displayName: user.displayName, picture: user.picture } : undefined}
        menuItems={
          <MenuItem
            name="Préférences de cookies"
            url="#"
            shape="square"
            onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
              e.preventDefault();
              (window as any).Cookiebot?.show();
            }}
          />
        }
      />
      <Outlet />
    </ContainerBucket>
  );
};

export default Bucket;

const ContainerBucket = styled('div')(() => ({
  margin: 0,
  width: '100%',
  display: 'grid',
  minHeight: '100vh',
  gridAutoColumns: 'minmax(auto, 100%)',
}));
